import { useState, useEffect } from 'react'
import clsx from 'clsx'
import IconUnbind from '@/components/icons/IconUnbind'
import { useWalletSelector } from '@/contexts/WalletSelectorContext'
import './WalletUnbindPopup.css'

const ANIMATION_TIME = 200

export default function WalletUnbindPopup({
  show,
  hidePopupCallback = () => {}
}) {
  const { signOut } = useWalletSelector()
  const [showElement, setShowElement] = useState(false)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (show) {
      setShowElement(true)
      setTimeout(() => setActive(true), 20)
    }
  }, [show])

  const onPopupClose = () => {
    setActive(false)
    setTimeout(() => {
      setShowElement(false)
      hidePopupCallback()
    }, ANIMATION_TIME)
  }

  const handleSignOut = async () => {
    signOut().then(onPopupClose)
  }
  return (
    <div
      className={clsx('popup-card-overlay', {
        show: showElement,
        active
      })}
    >
      <div className="popup-card wallet-unbind-popup">
        <IconUnbind className="icon-unbind" />
        <div className="wallet-unbind-popup-title">Disconnect your wallet?</div>
        <div className="wallet-unbind-popup-description">
          Gas fee will be required when you connect wallet again.
        </div>
        <div className="wallet-unbind-button noselect" onClick={handleSignOut}>
          Disconnect
        </div>
        <div
          className="wallet-unbind-text-button noselect"
          onClick={onPopupClose}
        >
          Cancel
        </div>
        <div className="popup-card-close-button" onClick={onPopupClose} />
      </div>
    </div>
  )
}
